import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'numberLabel' })
export class NumberLabelPipe implements PipeTransform {
    transform(translateKey: string, number: number): string {
        if (!translateKey || !Number.isFinite(number)) { return; }

        switch (number) {
            case 1:
                return `${ translateKey }.LESS_OR_EQUAL_1`;
            case 2:
            case 3:
            case 4:
                return `${ translateKey }.BETWEEB_2_4`;
            default:
                return `${ translateKey }.MORE_OR_EQUAL_5`;
        }
    }
}
